import React, { useState } from 'react';
import _ from 'underscore';

import { Block, Note, Dropdown, DropdownButton, DropdownMenu, DropdownItem, ArrowDown } from './styles';
import { Checkbox } from 'components/Checkbox/Checkbox';

export default function MultiSelectCheckboxDropdown({ title, options = {}, onSelect }) {
  const [optionsList, setOptionsList] = useState(options);

  const returnSelectedValues = (list) => {
    let selectedKeys = [];
    _.each(list, (val, key) => {
      if (list[key].selected) selectedKeys.push(key);
    });
    onSelect(selectedKeys);
  };

  const changeAllValueSelected = (allSelected) => {
    let updatedList = JSON.parse(JSON.stringify(optionsList));
    _.each(updatedList, (val, key) => {
      updatedList[key].selected = !allSelected;
    });
    setOptionsList(updatedList);
    returnSelectedValues(updatedList);
  };

  const changeSelectedValue = (key, value) => {
    let updatedList = JSON.parse(JSON.stringify(optionsList));
    updatedList[key].selected = !value;
    setOptionsList(updatedList);
    returnSelectedValues(updatedList);
  };

  const selectedCount = _.filter(optionsList, (value) => value.selected).length;
  const allSelected = _.keys(optionsList).length === selectedCount;

  return (
    <Block>
      <Note>{title}</Note>
      <Dropdown>
        <DropdownButton data-toggle="dropdown">
          {selectedCount > 0 ? `${selectedCount} selected` : 'Choose'} <ArrowDown />
        </DropdownButton>
        <DropdownMenu>
          <DropdownItem
            onClick={(e) => {
              e.stopPropagation();
              changeAllValueSelected(allSelected);
            }}
          >
            <Checkbox checked={allSelected} label={allSelected ? 'Unselect all' : 'Select all'} />
          </DropdownItem>
          {_.map(optionsList, (val, key) => (
            <DropdownItem
              key={key}
              onClick={(e) => {
                e.stopPropagation();
                changeSelectedValue(key, val.selected);
              }}
            >
              <Checkbox checked={val.selected} label={val.label} />
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </Block>
  );
}
